module.exports = __webpack_public_path__ + "img/arrow-shape-mobile.c4200076.svg";